import React from 'react';
import styles from './styles/LoadingScreen.module.css';

const LoadingScreen = () => {
    return (
        <div className={styles.loadingOverlay}>
            <div className={styles.spinner}></div>
            <p className={styles.loadingText}>Processando, aguarde um instante...</p>
        </div>
    );
};

export default LoadingScreen;